import React, { createContext, useContext, useState, useMemo } from 'react';

const EditModeContext = createContext();

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error('useEditMode must be used within EditModeProvider');
  }
  return context;
};

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(() => {
    // Recupera lo stato di login da sessionStorage
    return sessionStorage.getItem('isAdmin') === 'true';
  });

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const enableAdminMode = () => {
    setIsAdmin(true);
    sessionStorage.setItem('isAdmin', 'true');
  };

  const disableAdminMode = () => {
    setIsAdmin(false);
    setIsEditMode(false);
    sessionStorage.removeItem('isAdmin');
  };

  // Memoize context value to prevent unnecessary re-renders
  const value = useMemo(() => ({
    isEditMode,
    toggleEditMode,
    isAdmin,
    enableAdminMode,
    disableAdminMode
  }), [isEditMode, isAdmin]);

  return (
    <EditModeContext.Provider value={value}>
      {children}
    </EditModeContext.Provider>
  );
};
